import * as React from 'react';

import {ErrorMessage} from 'shells/form/error-message';

import type {LeadGoalCondition as LeadGoalConditionFragment} from 'nutshell-graphql-types';

import {ConditionCustomField} from './condition-custom-field';

import styles from './stage-goal-condition.module.css';

type Props = {
    goalCondition: LeadGoalConditionFragment;
};

export class StageGoalCondition extends React.PureComponent<Props> {
    render() {
        const isComplete = this.props.goalCondition.status === 'FULFILLED';
        const conditionText = this.props.goalCondition.condition.humanReadableObjectiveString;
        const conditionCustomField = this.props.goalCondition.conditionCustomField;

        return (
            <div className={isComplete ? styles['goals-goal--complete'] : styles['goals-goal']}>
                {conditionCustomField ? (
                    <ConditionCustomField
                        entityId={conditionCustomField.lead.id}
                        conditionText={conditionText}
                        field={conditionCustomField.node}
                        value={conditionCustomField.value}
                    />
                ) : (
                    this.renderBaseCondition(this.props.goalCondition)
                )}
            </div>
        );
    }

    renderBaseCondition = (goalCondition: LeadGoalConditionFragment) => {
        const conditionText = goalCondition.condition.humanReadableObjectiveString;
        // If the condition is invalid, lets render some helpful error text
        if (goalCondition.status === 'MISSING_CUSTOM_FIELD_ERROR') {
            return (
                <div>
                    <div className={styles['base-condition']}>{conditionText}</div>
                    <div className={styles['warning-message']}>
                        <ErrorMessage>
                            This goal needs to be updated - the field no longer exists
                        </ErrorMessage>
                    </div>
                </div>
            );
        } else if (goalCondition.status === 'UNKNOWN_ERROR') {
            return (
                <div>
                    <div className={styles['base-condition']}>{conditionText}</div>
                    <div className={styles['warning-message']}>
                        <ErrorMessage>
                            Something went wrong checking this goal. Please check that it is
                            properly configured.
                        </ErrorMessage>
                    </div>
                </div>
            );
        }

        return <div className={styles['base-condition']}>{conditionText}</div>;
    };
}
